<template>
    <div class="outer-wrapper">
        <div class="payment-info-wrapper">

            <div class="payment-info-form" >

                <div class="card-information-wrapper">

                    <div class="input-wrap" >
                        <p class="input-title">Address 1:</p>
                        <input type="text" class="input-data" placeholder="Enter Your Address"
                                v-model="addressInfo.addressOne"/>
                    </div>
                    
                    <div class="input-wrap" >
                        <p class="input-title">Address 2:</p>
                        <input type="text" class="input-data" placeholder="Enter Your Address"
                                v-model="addressInfo.addressTwo"/>
                    </div>

                    <div class="input-wrap" >
                        <p class="input-title">City:</p>
                        <input type="text" class="input-data" placeholder="Enter Your City"
                                v-model="addressInfo.addressCity"/>
                    </div>

                    <div class="small-sizing-inputs">

                        <div class="input-wrap" >
                            <p class="input-title">State:</p>
                            <select class="input-data" v-model="addressInfo.addressState">
                                <option value="" defaulf>Choose</option>
                                <option v-for="state in states" :value="state.id">
                                    {{ state.name }}
                                </option>
                            </select>
                        </div>

                        <div class="input-wrap">
                            <p class="input-title">Zip:</p>
                            <input type="text" class="input-data" autocomplete="shipping postal-code"
                                    placeholder="Enter your Zip"
                                    :maxlength="addressInfo.addressZip"
                                    v-model="addressInfo.addressZip"/>
                        </div>

                    </div>

                    <div class="delivery-instructions" >
                        <p class="input-title">{{ 'Delivery Instructions:' }}</p>
                        <textarea maxlength="160" rows="5" columns="200" placeholder="Optional" v-model=" deliveryInstructions ">
                        </textarea>
                    </div>
                    
                </div>
            </div>

            <DeliveryFeeError />

            <div class="pay-button-wrapper">
                <button :class=" NextButtonClass " type="button"
                        :disabled="!formValid"
                        @click="saveAddress()">
                    Next 
                </button>
            </div>

        </div>
        <div :class=" overlayClass " v-if="isLoadingOrder"><b>Please wait. Do not go back or refresh</b></div>
        <div v-if="isLoadingOrder">
            <loader object="#fcfcfc" color1="#ffffff" color2="#17fd3d" size="11" speed="1.1" bg="#343a40" objectbg="#999793" opacity="5" disableScrolling="true" name="dots"></loader>
        </div>
    </div>
</template>

<script>

    import { mapState, mapGetters } from 'vuex';
    import DeliveryFeeError from '../misc/DeliveryFeeError';

    export default {

        name: 'full-delivery',
        data: function(){

            return {

                addressInfo: {

                    addressOne : '',
                    addressTwo : '',
                    addressCity : '',
                    addressState : '',
                    addressZip : '',
                    addressCountry : 'US'
                },
                states,
                deliveryInstructions: '',
            }
        },
        computed: {

            ...mapState({

                currentTab       : state => state.orderTab.currentTab
            }),
            ...mapGetters({

                needsLocations      : 'merchant/needsLocations',
                locationError       : 'merchant/locationError',
                allLocations        : 'merchant/allLocations',
                currentMerchant     : 'merchant/currentMerchant',
                currentLocation     : 'merchant/currentLocation',
                deliverySelected    : 'merchant/deliverySelected',
                merchantSlug        : 'merchant/merchantSlug',
                previousRoute       : 'previousRoute',
                imageUrl            : 'imageUrl',
                isLoading           : 'isLoading',
                orderError          : 'merchant/orderError',
                getActiveOrder      : 'orders/getActiveOrder',
                isLoadingOrder      : 'merchant/isLoadingOrder',
                merchantIdCrocante  : 'merchantIdCrocante',
            }),
            formValid(){

                if( [ null, '' ].includes( this.addressInfo.addressOne       ) ) return false;
                if( [ null, '' ].includes( this.addressInfo.addressCity      ) ) return false;
                if( [ null, '' ].includes( this.addressInfo.addressState     ) ) return false;
                if( [ null, '' ].includes( this.addressInfo.addressZip       ) || ![ 5 ].includes( this.addressInfo.addressZip.length )  || this.addressInfo.addressZip.match( /[a-z]/i ) ) return false;
                return true;
            },
            NextButtonClass(){

                const base = [ 'button' ];
                base.push( this.currentLocation.merchantId == this.merchantIdCrocante ? 'btn-brown' : 'btn-aqua' )
                return base.join( ' ' );
            },
            overlayClass(){

                const base = [ 'overlay ' ];
                base.push( ( this.currentLocation.merchantId == this.merchantIdCrocante ) ? 'outPopUp color-font-crocante' : 'outPopUp color-font-xo' );

                return base.join( ' ' );

            }
        },
        methods: {

            saveAddress(){

                console.log( 'save full address delivery... ' );

                if ( this.formValid ) {

                    const FullDelivery = {

                        deliveryType : 'FullDelivery',
                        addressOne : this.addressInfo.addressOne,
                        addressTwo : this.addressInfo.addressTwo,
                        addressCity : this.addressInfo.addressCity,
                        addressState : this.addressInfo.addressState,
                        addressZip : this.addressInfo.addressZip,
                        addressCountry : this.addressInfo.addressCountry,
                        deliveryInstructions: this.deliveryInstructions,
                        goToOrderTab : false
                    };

                    this.$store.dispatch( 'merchant/selectedDelivery', FullDelivery );
                    this.$store.dispatch( 'merchant/getDeliveryFee', FullDelivery );
                    
                }
            },
            setDeliveryValues(){
                this.addressInfo.addressOne = this.deliverySelected.addressOne;
                this.addressInfo.addressTwo = this.deliverySelected.addressTwo;
                this.addressInfo.addressCity = this.deliverySelected.addressCity;
                this.addressInfo.addressState = this.deliverySelected.addressState;
                this.addressInfo.addressZip = this.deliverySelected.addressZip;
                this.deliveryInstructions = this.deliverySelected.deliveryInstructions;
            }
        },
        components: {

            DeliveryFeeError
        },
        created(){

            console.log( 'getting all locations api call...' );
            if (this.deliverySelected.deliveryType == 'FullDelivery') {
                this.addressInfo.addressOne = (this.deliverySelected.addressOne != '') ? this.deliverySelected.addressOne : '';
                this.addressInfo.addressTwo = (this.deliverySelected.addressTwo != '') ? this.deliverySelected.addressTwo : '';
                this.addressInfo.addressCity = (this.deliverySelected.addressCity != '') ? this.deliverySelected.addressCity : '';
                this.addressInfo.addressState = (this.deliverySelected.addressState != '') ? this.deliverySelected.addressState : '';
                this.addressInfo.addressZip = (this.deliverySelected.addressZip != '') ? this.deliverySelected.addressZip : '';
                this.deliveryInstructions = (this.deliverySelected.deliveryInstructions != '') ? this.deliverySelected.deliveryInstructions : '';
            }
            
            this.$store.dispatch( 'merchant/getLocations' );
        }
    }
    
    const states = [
        {
            "id" : "AK",
            "name" : "Alaska"
        },
        {
            "id" : "AL",
            "name" : "Alabama"
        },
        {
            "id" : "AR",
            "name" : "Arkansas"
        },
        {
            "id" : "AS",
            "name" : "American Samoa"
        },
        {
            "id" : "AZ",
            "name" : "Arizona"
        },
        {
            "id" : "CA",
            "name" : "California"
        },
        {
            "id" : "CO",
            "name" : "Colorado"
        },
        {
            "id" : "CT",
            "name" : "Connecticut"
        },
        {
            "id" : "DC",
            "name" : "District of Columbia"
        },
        {
            "id" : "DE",
            "name" : "Delaware"
        },
        {
            "id" : "FL",
            "name" : "Florida"
        },
        {
            "id" : "GA",
            "name" : "Georgia"
        },
        {
            "id" : "GU",
            "name" : "Guam"
        },
        {
            "id" : "HI",
            "name" : "Hawaii"
        },
        {
            "id" : "IA",
            "name" : "Iowa"
        },
        {
            "id" : "ID",
            "name" : "Idaho"
        },
        {
            "id" : "IL",
            "name" : "Illinois"
        },
        {
            "id" : "IN",
            "name" : "Indiana"
        },
        {
            "id" : "KS",
            "name" : "Kansas"
        },
        {
            "id" : "KY",
            "name" : "Kentucky"
        },
        {
            "id" : "LA",
            "name" : "Louisiana"
        },
        {
            "id" : "MA",
            "name" : "Massachusetts"
        },
        {
            "id" : "MD",
            "name" : "Maryland"
        },
        {
            "id" : "ME",
            "name" : "Maine"
        },
        {
            "id" : "MI",
            "name" : "Michigan"
        },
        {
            "id" : "MN",
            "name" : "Minnesota"
        },
        {
            "id" : "MO",
            "name" : "Missouri"
        },
        {
            "id" : "MS",
            "name" : "Mississippi"
        },
        {
            "id" : "MT",
            "name" : "Montana"
        },
        {
            "id" : "NC",
            "name" : "North Carolina"
        },
        {
            "id" : " ND",
            "name" : " North Dakota"
        },
        {
            "id" : "NE",
            "name" : "Nebraska"
        },
        {
            "id" : "NH",
            "name" : "New Hampshire"
        },
        {
            "id" : "NJ",
            "name" : "New Jersey"
        },
        {
            "id" : "NM",
            "name" : "New Mexico"
        },
        {
            "id" : "NV",
            "name" : "Nevada"
        },
        {
            "id" : "NY",
            "name" : "New York"
        },
        {
            "id" : "OH",
            "name" : "Ohio"
        },
        {
            "id" : "OK",
            "name" : "Oklahoma"
        },
        {
            "id" : "OR",
            "name" : "Oregon"
        },
        {
            "id" : "PA",
            "name" : "Pennsylvania"
        },
        {
            "id" : "PR",
            "name" : "Puerto Rico"
        },
        {
            "id" : "RI",
            "name" : "Rhode Island"
        },
        {
            "id" : "SC",
            "name" : "South Carolina"
        },
        {
            "id" : "SD",
            "name" : "South Dakota"
        },
        {
            "id" : "TN",
            "name" : "Tennessee"
        },
        {
            "id" : "TX",
            "name" : "Texas"
        },
        {
            "id" : "UT",
            "name" : "Utah"
        },
        {
            "id" : "VA",
            "name" : "Virginia"
        },
        {
            "id" : "VI",
            "name" : "Virgin Islands"
        },
        {
            "id" : "VT",
            "name" : "Vermont"
        },
        {
            "id" : "WA",
            "name" : "Washington"
        },
        {
            "id" : "WI",
            "name" : "Wisconsin"
        },
        {
            "id" : "WV",
            "name" : "West Virginia"
        },
        {
            "id" : "WY",
            "name" : "Wyoming"
        }
    ];

</script>

<style scoped>

    .outer-wrapper {

        min-height: 100%;
    }

    .card-row {

        display: flex;
        justify-content: space-between;
        align-items: center;

        padding: 20px 30px 0px;
        max-width: 800px;
        margin: 0px auto;
    }
    .card-row > img {

        width: 22%;
    }

    .payment-cof-options-wrapper {

        display: flex;
        align-items: center;
        margin: 20px auto;
        padding: 0px 15px;
    }

    .payment-cof-action {

        flex: 1;
        text-align: center;
    }

    .payment-cof-action > button {

        margin: 0px 10px;
        box-sizing: border-box;
    }

    .payment-amount-wrapper {

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 115px;
    }
    .payment-title{

        font-size: 22px;
    }
    .payment-total{

        font-weight: bold;
        font-size: 30px;
    }

    .card-information-wrapper {

        margin: 0px 0px 15px;
        padding: 0px 15px;
    }

    .input-title {

        font-size: 18px;
    }
    .input-data {

        width: 100%;
        margin: 3px 1px;
        height: 45px;
        border-radius: 8px;
        border: 1px solid #ccc;
        padding: 0px 10px;
        font-size: 18px;
        transition: all 0.2s ease-in;
    }
    .input-data:focus {

        outline: none;
        border: 1px solid blue;
        box-shadow: 0px 2px 20px -5px blue;
    }
    .input-data::-webkit-input-placeholder {

        text-align: center;
    }

    .small-sizing-inputs {

        display: flex;
        justify-content: space-between;
    }
    .small-sizing-inputs > .input-wrap {

        width: 100%;
    }
    .small-sizing-inputs > .input-wrap:nth-child( 1 ) > .input-data {

        border-radius: 0;
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
        font-size: 14px;
    }
    .small-sizing-inputs > .input-wrap:nth-child( 2 ) > .input-data {

        border-radius: 0;
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
    }


    .pay-button-wrapper {

        padding: 0px 15px;
        margin-bottom: 15px;
    }
    .pay-button-wrapper > button {

        width: 100%;
        height: 50px;
        font-size: 18px;
    }

    .lock-icon {

        width: 25px;
    }

    .delivery-instructions {

        padding: 8px 0px;
        font-size: 0.9rem;
        font-weight: bold;
        color: #777;
    }
    .delivery-instructions > textarea {

        width: 100%;
        margin: 0px 1px;
    }

    .overlay {
        margin: 0px auto;
        display: flex;
        align-items: center;
        justify-content: center;
        align-content: center;
        text-align: center;
        font-size: 18px;
        font-weight: bold;
    }

    .color-font-crocante {
        color: #4A2612;
        /* background: #DFEC72; */
    }

    .color-font-xo {
        color: white;
        /* background: rgba(240, 11, 11, 0.822) */
    }

    .outPopUp {
        position: fixed;
        width: 100%;
        height: 100%;
        z-index: 1000;
        left: 0;
        top: 0;
        background: rgba(124, 135, 156, 0.822)
    }
</style>